import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';

import style from './style';
import LazyImage from '../../Layouts/LazyImage';

const WhatWeWorking = ({ data }) => {
  const classes = style();

  return (
    <Box className={classes.segment}>
      <Container>
        <Grid container justifyContent={'center'}>
          <Grid item xs={12} md={10}>
            <Grid container justifyContent="center">
              <Grid item xs={12} sm={6}>
                <Typography
                  align="center"
                  className={classes.mainHeading}
                  variant="h2"
                >
                  {data.title}
                </Typography>
              </Grid>
            </Grid>
            <Grid container justifyContent={'space-evenly'} spacing={4}>
              {data.contents.map((content, key) => {
                return (
                  <Grid
                    item
                    xs={11}
                    sm={6}
                    md={4}
                    className={classes.card}
                    key={key}
                  >
                    <LazyImage
                      sizes={sizes}
                      radius={2}
                      sx={{ mb: 2 }}
                      quality={90}
                      src={content.img}
                      alt=""
                    />

                    <Typography
                      className={classes.content}
                      variant="h4"
                      align="center"
                      gutterBottom
                    >
                      {content.title}
                    </Typography>
                    <Typography
                      align="center"
                      className={classes.content}
                      variant="subtitle1"
                      color={'textSecondary'}
                    >
                      {content.description}
                    </Typography>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </Grid>
      </Container>{' '}
    </Box>
  );
};

const sizes = {
  xxl: [274, 308, false],
};

export default WhatWeWorking;
